/* ROI calculator — cost per impression comparison */
(function () {
  function init(root) {
    if (!root || root.dataset.roiReady === 'true') return;
    root.dataset.roiReady = 'true';
    var f = {
      priceA: root.querySelector('[data-roi="priceA"]'),
      wearsA: root.querySelector('[data-roi="wearsA"]'),
      priceB: root.querySelector('[data-roi="priceB"]'),
      wearsB: root.querySelector('[data-roi="wearsB"]'),
      cpwA: root.querySelector('[data-roi="cpwA"]'),
      cpwB: root.querySelector('[data-roi="cpwB"]'),
      label: root.querySelector('[data-roi="verdictLabel"]'),
      value: root.querySelector('[data-roi="verdictValue"]'),
      invDiff: root.querySelector('[data-roi="invDiff"]'),
      valMult: root.querySelector('[data-roi="valMult"]')
    };
    var minB = parseFloat(root.dataset.minImpressions || '50');
    var labelQuality = root.dataset.labelQuality || 'ROI on Quality Garment (vs Basic)';
    var labelBasic = root.dataset.labelBasic || 'ROI on Basic Garment (vs Quality)';

    function num(el) { var n = parseFloat(el && el.value); return isFinite(n) ? n : 0; }
    function fmt(c) { return c === null ? '\u2014' : '$' + c.toFixed(2); }

    function render() {
      var pa = num(f.priceA), wa = num(f.wearsA), pb = num(f.priceB), wb = num(f.wearsB);
      var cA = wa > 0 ? pa / wa : null;
      var cB = wb > 0 ? pb / wb : null;
      if (f.cpwA) f.cpwA.textContent = fmt(cA);
      if (f.cpwB) f.cpwB.textContent = fmt(cB);

      var vLabel = 'Enter values to compare', vValue = '\u2014';
      if (cA !== null && cB !== null && cA > 0 && cB > 0) {
        if (cB < cA) { vLabel = labelQuality; vValue = (cA / cB).toFixed(1) + '\u00d7'; }
        else if (cA < cB) { vLabel = labelBasic; vValue = (cB / cA).toFixed(1) + '\u00d7'; }
        else { vLabel = 'Equal value'; vValue = '1.0\u00d7'; }
      }
      if (f.label) f.label.textContent = vLabel;
      if (f.value) f.value.textContent = vValue;

      var diff = pb - pa;
      if (f.invDiff) f.invDiff.textContent = '$' + Math.abs(diff).toFixed(diff % 1 === 0 ? 0 : 2);
      if (f.valMult) {
        f.valMult.textContent = (cA !== null && cB !== null && cB > 0 && cB < cA)
          ? Math.floor(cA / cB) + '\u00d7' : 'more';
      }
    }

    if (f.priceA) f.priceA.addEventListener('input', render);
    if (f.wearsA) f.wearsA.addEventListener('input', render);
    if (f.priceB) f.priceB.addEventListener('input', render);
    if (f.wearsB) {
      f.wearsB.addEventListener('input', render);
      f.wearsB.addEventListener('change', function () {
        var n = parseFloat(f.wearsB.value);
        if (f.wearsB.value !== '' && isFinite(n) && n < minB) f.wearsB.value = String(minB);
        render();
      });
    }
    render();
  }

  function initAll() {
    document.querySelectorAll('[data-roi-calculator]').forEach(init);
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
